import { InfluencerPayments } from "../../typings";
import { sendRequest } from "../helper";

export type CampaignDealResult = {
  status: "SUCCESS";
  message: "Fetching All Campaign Payments";
  data: InfluencerPayments;
};

type getCampaignAllDealsProps = {
  page?: number;
  campaignId?: string;
};

export const getCampaignAllDeals = ({
  page,
  campaignId,
}: getCampaignAllDealsProps) => {
  const queryKey = ["campaigns", "deal", campaignId, page];

  const queryFunction = () =>
    sendRequest<CampaignDealResult>(
      "get",
      `/brand/offer/payment/in-payment?campaignId=${campaignId}&page=${page}&limit=4`,
      false
    ).then((res) => res.data);
  return [queryKey, queryFunction] as const;
};
